<template>
  <div :class="{'hidden':hidden || !total}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="processedPageSizes"
      :pager-count="pagerCount"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import {scrollTo} from '@/utils/scroll-to'


export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 1
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    // 移动端页码按钮的数量端默认值5
    pagerCount: {
      type: Number,
      default: document.body.clientWidth < 992 ? 5 : 7
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    // 确保page-size包含当前limit
    processedPageSizes() {
      const newPageSizes = [...this.pageSizes]

      if (typeof this.limit === 'number' && this.limit > 0 && !newPageSizes.includes(this.limit)) {
        newPageSizes.push(this.limit)
        // 升序排序
        newPageSizes.sort((a, b) => a - b)
      }
      return newPageSizes
    },
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    // 页面滚动
    scrollToTop() {
      this.$nextTick(() => scrollTo(0, 1200))
    },
    //
    handleSizeChange(val) {
      this.$emit('pagination', {pageNum: 1, pageSize: val})
      this.autoScroll && this.scrollToTop()
    },
    //
    handleCurrentChange(val) {
      this.$emit('pagination', {pageNum: val, pageSize: this.pageSize})
      this.autoScroll && this.scrollToTop()
    }
  }
}
</script>

<style scoped lang='scss'>
.pagination-container {
  height: auto;
  text-align: right;
  margin: 0;
  padding: 10px 5px 5px !important;

  .el-pagination {
    position: static;
    display: inline-block;
  }

  /deep/ .el-pagination__total {
    height: 34px;
    line-height: 34px;
    font-size: 15px;
  }

  /deep/ .el-pagination__sizes .el-input .el-input__inner {
    font-size: 14px;
    border-radius: 4px;
    height: 34px;
    line-height: 34px;
    background: #fff;
    color: #14181F;
    border-color: #DCE0E5;
  }

  /deep/ .el-pagination.is-background .btn-prev, .el-pagination.is-background .btn-next, .el-pagination.is-background .el-pager li,
  /deep/ .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    height: 34px;
    line-height: 34px;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #DCE0E5;
    color: #14181F;
  }

  /deep/ .el-pagination.is-background .btn-prev:disabled, /deep/ .el-pagination.is-background .btn-next:disabled {
    color: #B6C1CA;
  }

  /deep/ .el-pager {
    li {
      height: 34px;
      line-height: 34px;
      border-radius: 4px;
      background: #fff;
      border: 1px solid #DCE0E5;
      color: #14181F;
      font-weight: 500;
      min-width: 34px;
      margin: 0 3px;
    }

    li:hover {
      color: #14181F !important;
    }

    & li.active {
      border: none;
      color: #fff !important;
    }
  }

  /deep/ .el-pagination__jump {
    font-size: 15px;
    height: 34px;
    line-height: 34px;
  }

  /deep/ .el-pagination__editor.el-input .el-input__inner {
    height: 34px;
    line-height: 34px;
    color: #14181F;
    border-color: #DCE0E5;
  }
}

.pagination-container.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue